export default "__VITE_ASSET__DmJAYRFm__"